/**
 * Shared utility to resolve a human-readable section title from an outline
 * section object. Narrative-document sections carry `title`; questionnaire
 * items carry `prompt` (and an optional `number`). Returns undefined when
 * neither is available so callers can fall back to the raw section key.
 */

const SECTION_TITLE_MAX = 80

export function resolveSectionTitle(section: unknown): string | undefined {
  if (!section || typeof section !== 'object') return undefined
  const s = section as { title?: string; prompt?: string; number?: string }
  if (s.title && s.title.trim().length > 0) return s.title.trim()
  if (s.prompt && s.prompt.trim().length > 0) {
    const prompt = s.prompt.trim()
    const label = s.number ? `${s.number} ${prompt}` : prompt
    return label.length > SECTION_TITLE_MAX
      ? `${label.slice(0, SECTION_TITLE_MAX - 1)}…`
      : label
  }
  return undefined
}
